/** @format */

import React from 'react'

import { Card, Col, Row } from 'antd'

import EditProduct from '../EditRutOrRecipe'

export default function Rut({ product, order, handleEditRutOrRecipe }) {
	return (
		<Row gutter={12}>
			<Col span={12}>
				<Card bordered={false} cover={<img alt='Identificación del usuario' src={product.rut} />}>
					<Card.Meta
						title='Identificación del usuario'
						description={
							<a href={product.rut} target='_blank' rel='noopener noreferrer'>
								Ir a la página de Identificación
							</a>
						}
					/>
				</Card>
			</Col>
			<Col span={12}>
				<Card title='Acciones Disponibles:' bordered={false}>
					<EditProduct product={product} type='Rut' handleEditRutOrRecipe={handleEditRutOrRecipe} />
				</Card>
			</Col>
		</Row>
	)
}
